import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { LinkWithAnalytics } from '../Link/Link';
import Image from '../Image/Image';
import { gameImageSelector } from '../../redux/reducers/app/configuration';
import { useIsDesktopLayout } from '../../hooks/useIsDesktopLayout';
import { getGameDetailRoute } from '../../utils/routes';
import { getGameImagePath } from '../../utils/imagePath';
import { getDataTestAttrs } from '../../utils/testing-locators';
import {
  QUICK_SEARCH_GAME_LINK,
  QUICK_SEARCH_GAME_IMAGE,
} from '../../constants/dataTestIds';
import styles from './QuickSearchItem.module.css';

export const QuickSearchItem = ({
  id,
  translationKey,
  routeState,
  ...props
}) => {
  const imagePath = useSelector(gameImageSelector);
  const isDesktop = useIsDesktopLayout();

  return (
    <LinkWithAnalytics
      to={{ pathname: getGameDetailRoute(id), state: routeState }}
      className={styles.link}
      {...getDataTestAttrs(QUICK_SEARCH_GAME_LINK, id)}
      {...props}
    >
      <div className={styles['image-container']}>
        <Image
          className={styles.image}
          src={getGameImagePath(imagePath, id, isDesktop)}
          alt={translationKey}
          {...getDataTestAttrs(QUICK_SEARCH_GAME_IMAGE)}
        />
      </div>
      {translationKey}
    </LinkWithAnalytics>
  );
};

QuickSearchItem.propTypes = {
  id: PropTypes.string.isRequired,
  translationKey: PropTypes.string.isRequired,
  routeState: PropTypes.shape({}),
};

QuickSearchItem.defaultProps = {
  routeState: {},
};

export default memo(QuickSearchItem);
